import {
  Domaenenwert,
  Kommunikation,
  Programmname,
  ProgrammteilnahmeEmailFieldBehaviour,
  ProgrammteilnahmeStatus,
  Verwendung,
} from '@ps20/bff-models';

export interface KommDaten extends Kommunikation {
  angabeStatus: AngabeStatus;
  vorbelegt: boolean;
  herkunft?: string;
  laendervorwahl?: string;
}

export interface KommDatenEmail extends KommDaten {
  fieldBehaviour: ProgrammteilnahmeEmailFieldBehaviour;
  programmName?: Programmname;
  programmStatus?: ProgrammteilnahmeStatus;
  changedByUser: boolean;
  changedByProgrammteilnahme?: boolean;
}

export enum AngabeStatus {
  NICHT_VORHANDEN = 'NICHT_VORHANDEN',
  KEINE_ANGABE = 'KEINE_ANGABE',
}

export function getAngabeStatusTextKeys(angabeStatus: AngabeStatus): string {
  return {
    [AngabeStatus.KEINE_ANGABE]: 'versicherungsnehmer.kommunikationsdateAngabeRadios.keineAngabe',
    [AngabeStatus.NICHT_VORHANDEN]:
      'versicherungsnehmer.kommunikationsdateAngabeRadios.nichtVorhanden',
  }[angabeStatus];
}

export function convertSafeDomaenenwert(domaenenwertFe: Domaenenwert): Domaenenwert {
  return domaenenwertFe ?? null;
}

export function convertToKommVerwendung(verwendungen: Verwendung[]): Verwendung[] {
  if (!verwendungen) {
    return [];
  }
  return verwendungen.map(verwendung => {
    return {
      ...verwendung,
      verwendungszweck: convertSafeDomaenenwert(verwendung.verwendungszweck),
    };
  });
}

export function convertToKommDaten(kommunikation: Kommunikation): KommDaten | KommDatenEmail {
  return {
    ...kommunikation,
    vorbelegt: true,
    angabeStatus: null,
    changedByProgrammteilnahme: false,
  };
}
